import { colorIsLight } from 'fabscale-app/utilities/utils/color';

export default function colorIsLightHelper(color: string): boolean {
  return colorIsLight(color);
}
